/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_PublicInputs */

const zh_publish_public = /** @type {(inputs: Publish_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开`)
};

const en_publish_public = /** @type {(inputs: Publish_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const es_publish_public = /** @type {(inputs: Publish_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Publish_PublicInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const publish_public = /** @type {((inputs?: Publish_PublicInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_PublicInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_public(inputs)
	if (locale === "en") return en_publish_public(inputs)
	return es_publish_public(inputs)
});